var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bga-layout-top-bar'),_vm._v(" "),_c('div',{attrs:{"id":"layoutSidenav"}},[_c('bga-layout-side-bar'),_vm._v(" "),_c('div',{attrs:{"id":"layoutSidenav_content"}},[_c('main',[_vm._t("default")],2),_vm._v(" "),_c('bga-layout-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }